import type React from 'react';
import { HashRouter, Navigate, Route, Routes } from 'react-router-dom';
import AuthModal from './components/AuthModal';
import Navbar from './components/Navbar';
import { AuthProvider } from './contexts/AuthContext';
import { ThemeProvider } from './contexts/ThemeContext';
import AdminDashboard from './pages/AdminDashboard';
import NewOrder from './pages/NewOrder';
import SpinWheel from './pages/SpinWheel';
import UserPanel from './pages/UserPanel';

const App: React.FC = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <HashRouter>
          <div className="min-h-screen text-slate-900 dark:text-slate-100">
            <Navbar />
            <AuthModal />
            <main>
              <Routes>
                <Route path="/" element={<NewOrder />} />
                <Route path="/spin" element={<SpinWheel />} />
                <Route path="/account" element={<UserPanel />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </HashRouter>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
